<template>
  <div class="footer">
    <v-footer light height="auto">
      <v-card
        flat
        class="flex xs12 py-2"
        color="transparent"
      >
        <v-card-text>
          <v-btn
            v-for="social in socials"
            :key="social.icon"
            class="mx-1"
            icon
            :href="social.url"
            target="_blank"
          >
            <v-icon size="24px">{{ social.icon }}</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-footer>

    <v-footer dark height="auto">
      <v-card
        flat
        class="flex xs12 py-3 pt-4"
        color="transparent"
      >
        <v-card-text>
          <p>
            © {{ date }} All rights reserved. Made with ❤ in Waterloo.
          </p>
          <v-btn dark to="/legal">Legal</v-btn>
          <v-btn dark to="/login" v-if="!isAuth">Login</v-btn>
          <v-btn dark to="/admin" v-if="isAuth">Admin</v-btn>
        </v-card-text>
      </v-card>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'siteFooter',
  data () {
    return {
      socials: [
        {
          icon: 'fab fa-twitter',
          url: 'https://twitter.com/tdlab'
        },
        {
          icon: 'fab fa-medium',
          url: 'https://medium.com/td-lab'
        },
        {
          icon: 'fab fa-instagram',
          url: 'http://instagram.com/tdlab_'
        }
      ]
    }
  },
  computed: {
    date () {
      var date = new Date()
      return date.getFullYear()
    },
    isAuth () {
      return this.$store.state.isAuth
    }
  }
}
</script>
